import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	Image,
	TextAlignment,
	AspectRatioContainer,
	CTA,
	Spinner,
	ContainerGutter,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { TelefonoInput } from '../../../oneform/components/telefono-input';
import { DealersRadio } from '../../../oneform/components/dealers-radio';
import { VWBookParticipado } from './vwBookParticipado';
import { VWBookAgotado } from './vwBookAgotado';

export const VWBookParticipa: React.FC = () => {
	const [participando, setParticipando] = React.useState<boolean>(false);
	const [estadoParticipacion] = React.useState<'participa' | 'participado' | 'agotado'>('participa');
	const [phoneData, setPhoneData] = React.useState({ prefix: '+34', phoneNumber: '' });
	const [dealerData, setDealerData] = React.useState<any>(null);

	const handleParticipate = () => {
		setParticipando(true);

		// 	portalService.postParticipateVWBook('ClubWrap2025', dealer, telefono).subscribe({
		// 		next: (response: GetPersonUser | null) => {
		// 			setParticipando(false);

		// 			if (response !== null && response.portalUser.data) {
		// 				const promotions = response.portalUser.data.promotions;

		// 				if (promotions?.ClubWrap2025?.hasParticipated) {
		// 					setEstadoParticipacion('participado');
		// 				} else {
		// 					setEstadoParticipacion('agotado');
		// 				}
		// 			} else {
		// 				showAlert();
		// 			}
		// 		},
		// 		error: () => {
		// 			showAlert();
		// 		},
		// 	});
	};

	if (estadoParticipacion === 'participado') {
		return <VWBookParticipado />;
	}

	if (estadoParticipacion === 'agotado') {
		return <VWBookAgotado />;
	}
	const isFormValid = phoneData.phoneNumber.trim() !== '' && dealerData !== null;

	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<AspectRatioContainer data-testid="aspect-ratio-container" ratio="16:9">
				<Image
					src={
						'https://assets.volkswagen.com/is/image/volkswagenag/alerta_layer_libro_1600x1200px?Zml0PWNyb3AlMkMxJndpZD0xNjAwJmhlaT0xMjAwJmZtdD1qcGVnJnFsdD03OSZiZmM9b2ZmJmM3MWE='
					}
					alt="Imagen VW Book"
					style={{ borderRadius: '16px', objectFit: 'cover' }}
				/>
			</AspectRatioContainer>
			<Container
				wrap={'always'}
				padding={{
					top: ContainerPadding.dynamic0130,
				}}
			>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					Un recorrido por la historia de Volkswagen a través de su diseño
					<Text bold>{'\u0020¡Consigue tu libro de regalo!'}</Text>
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Queremos agradecerte que formes parte del Club Volkswagen con un regalo muy especial.
					</Text>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Ahora tienes la oportunidad de llevarte una
						<Text bold>{'\u0020edición limitada del libro de diseño Volkswagen: Creating Memories.\u0020'}</Text> Un
						viaje inspirador por la esencia de la marca, donde iconos como el Beetle, el Golf o el Polo muestran cómo el
						diseño va mucho más allá de la estética.
					</Text>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text bold appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Rellena los siguientes datos si quieres conseguir el tuyo, ¡date prisa, unidades limitadas!
					</Text>
				</Container>

				<Container
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					gutter={ContainerGutter.dynamic0100}
					wrap={'always'}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text bold appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						¿Nos compartes un teléfono de contacto?
					</Text>
					<TelefonoInput
						prefix={phoneData.prefix}
						phoneNumber={phoneData.phoneNumber}
						onChange={(data) => setPhoneData(data)}
						required
					/>
				</Container>

				<Container
					padding={{
						top: ContainerPadding.dynamic0130,
					}}
					gutter={ContainerGutter.dynamic0100}
					wrap={'always'}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text bold appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.center}>
						¿Qué concesionario te queda más cerca?
					</Text>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						Elige tu punto de venta de preferencia para venir a buscar tu edición especial del Libro de diseño
						Volkswagen.
					</Text>
					<DealersRadio onDealerSelect={(dealer) => setDealerData(dealer)} />
				</Container>

				<Container
					padding={{
						top: ContainerPadding.dynamic0050,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<CTA
						tag="button"
						aria-label="CTA vouchers redirect"
						size="large"
						disabled={participando || !isFormValid}
						icon={participando ? <Spinner /> : undefined}
						onClick={handleParticipate}
					>
						<Text bold> {participando ? '' : 'Quiero el libro de regalo'}</Text>
					</CTA>
				</Container>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0150,
						bottom: ContainerPadding.dynamic0130,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text
						appearance={TokenTextAppearance.copy100}
						color={TokenTextColor.secondary}
						textAlign={TextAlignment.center}
					>
						{
							'Para poder obtener de forma gratuita una de las 400 unidades de la edición limitada del Libro de diseño Volkswagen es necesario ser miembro del Club Volkswagen y cumplimentar debidamente el correspondiente formulario de solicitud al cual podrás acceder a través del siguiente enlace\u0020'
						}
						<CTA
							tag="a"
							aria-label="CTA bases legales"
							size="large"
							emphasis="tertiary"
							onClick={() => {
								window.open('https://www.volkswagen.es/es/clientes/mi-club-volkswagen.html', '_blank');
							}}
						>
							<Text>https://www.volkswagen.es/es/clientes/mi-club-volkswagen.html, </Text>
						</CTA>
						{'\u0020debiendo seleccionar el Concesionario al que acudirás a recoger el Libro.'}
					</Text>
					<Text
						appearance={TokenTextAppearance.copy100}
						color={TokenTextColor.secondary}
						textAlign={TextAlignment.center}
					>
						Promoción válida hasta fin de existencias.
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
